import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import { StyledTableRow } from '../../Product/ProductTabRowTable';
import { ZemplinLoaderWrapper } from '../../../..';
import { TableWrapper } from '../../General/TableWrapper';
import { FlexRow } from '../../../Defaults/Flexbox/Flexbox';
import { RequestTabRow } from './RequestTabRow';
import { TableTh } from '../../General/Table';
import { RequestTabRowMobile } from './RequestTabRowMobile';

const COLUMNS = [
  { name: 'Produkt na dopyt' },
  { name: 'Množstvo', align: 'center' },
  { name: 'Poznámka' },
  { name: '' },
];
interface Props {
  products: any;
  isFetching: boolean;
  removeFromCart: any;
  addToRequest: any;
  visible?: boolean;
  changeCartItemNote: (gId: number, note: string) => void;
}

function RequestProductTable({
  products,
  isFetching,
  removeFromCart,
  addToRequest,
  visible = true,
  changeCartItemNote,
}: Props) {
  const productsComponent =
    products &&
    products.map((p: any) => (
      <StyledTableRow key={p.product.product_id}>
        <RequestTabRow
          removeFromCart={removeFromCart}
          addToRequest={addToRequest}
          changeCartItemNote={changeCartItemNote}
          product={p}
        />
      </StyledTableRow>
    ));

  const mobileProductsComponent =
    products &&
    products.map((p: any) => (
      <RequestTabRowMobile
        key={p.product.product_id}
        removeFromCart={removeFromCart}
        addToRequest={addToRequest}
        changeCartItemNote={changeCartItemNote}
        product={p}
      />
    ));

  const headers =
    COLUMNS &&
    COLUMNS.map((item: any, i) => (
      <StyledTableTh
        width={item.width}
        minWidth={item.minWidth}
        align={item.align || 'left'}
        key={i}
      >
        {item.name}
      </StyledTableTh>
    ));

  return (
    <Wrapper visible={visible}>
      {isFetching ? (
        <ZemplinLoaderWrapper height={500} />
      ) : (
        <>
          <DesktopListProductsWrapper>
            <TableWrapper
              noItemsText={__('Nenašli sa dopytované produkty')}
              headers={headers}
              rows={productsComponent}
            />
          </DesktopListProductsWrapper>
          <MobileListProductsWrapper>
            {mobileProductsComponent}
          </MobileListProductsWrapper>
        </>
      )}
    </Wrapper>
  );
}

const animateIn = keyframes`
   0% {
    opacity: 0;
    transform: scale(0.6) translateY(-8px);
  }
  
  100% {
    opacity: 1;
  }
`;

const Wrapper = styled(FlexRow)<{ visible: boolean }>`
  flex-flow: row wrap;
  margin-bottom: ${({ visible }) => (visible ? rem(24) : 0)};
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  animation: ${animateIn} 0.2s ease;

  ${({ theme }) => theme.mediab.m810`
     margin-bottom: 0;
  `}
`;

const DesktopListProductsWrapper = styled.div`
  display: block;
  width: 100%;

  ${({ theme }) => theme.mediab.m810`
    display: none;
  `}
`;

const MobileListProductsWrapper = styled.div`
  display: none;
  width: 100%;

  ${({ theme }) => theme.mediab.m810`
      display: flex;
      justify-content: center;
      flex-flow: column;
  `}
`;

const StyledTableTh = styled(TableTh)`
  padding-bottom: ${rem(24)};
`;

export { RequestProductTable };
